import React from "react";
import UserDetails from "./user_details";
import FileHandler from "./file_handler";
import { useSelector } from "react-redux";

const FillFile = () => {
  const user = useSelector((state) => state.user);

  return (
    <div className="card container" style={{ marginTop: "5px" }}>
      <UserDetails user={user} />
      <FileHandler />
    </div>
  );
};

export default FillFile;